import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Grid,
} from "@mui/material";
import Logo from "../../assets/images/steelbudy-logo.svg";
import { API_ENDPOINTS } from "../../config/api";
import "./login-new.css";





const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear errors for the field being edited
    setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
    setErrorMessage(""); // Clear general error message on input change
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = ["Please enter an email address"];
    }
    if (!formData.password.trim()) {
      newErrors.password = ["Please enter a password"];
    }
    return newErrors;
  };

  const handleLogin = async (e) => {
    console.log("handleLogin called"); // Debug log
    e.preventDefault();
    setErrors({});
    setErrorMessage("");
    setIsLoading(true);

    // Client-side validation
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setErrorMessage("Please enter email and password");
      setIsLoading(false);
      return;
    }

    try {
      console.log("Attempting login with:", formData); // Debug log
      const response = await axios.post(API_ENDPOINTS.AUTH.LOGIN, formData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      console.log("Login response:", response.data); // Debug log

      const token = response.data.access_token || response.data.token;
      const user = response.data.user
        ? {
            ...response.data.user,
            roles: response.data.roles || [],
            permissions: response.data.permissions || [],
          }
        : null;

      if (token && user) {
        localStorage.setItem("token", token);
        localStorage.setItem("userData", JSON.stringify(user));
        login(user, token);
        const from = location.state?.from?.pathname || "/dashboard";
        console.log("Navigating to:", from); // Debug log
        navigate(from, { replace: true });
      } else {
        setErrorMessage("Invalid response format from server. Please try again.");
      }
    } catch (error) {
      console.error("Login error:", error); // Debug log
      let errorMsg = "An error occurred. Please try again.";

      if (error.response) {
        console.log("Error response:", error.response); // Debug log
        if (error.response.status === 422) {
          setErrors(error.response.data.errors || {});
          errorMsg = "Please check the provided information.";
        } else if (error.response.status === 401) {
          errorMsg = "Invalid email or password. Please check your credentials.";
          setErrors({
            email: ["Invalid credentials"],
            password: ["Invalid credentials"],
          });
        } else if (error.response.status === 500) {
          errorMsg = "Server error. Please try again later.";
        } else {
          errorMsg = error.response.data.message || "Login failed. Please try again.";
        }
      } else if (error.request) {
        errorMsg = "No response from server. Please check your connection.";
      }

      setErrorMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-wrapper-login">
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Card className="login-card" sx={{ width: "100%", mt: 3 }}>
          <CardContent>
            <img src={Logo} alt="SteelBuddy Logo" style={{ display: "block", margin: "0 auto" }} />

            {errorMessage && (
              <Alert severity="error" sx={{ mb: 2, mt: 2 }}>
                {errorMessage}
              </Alert>
            )}
            <Typography component="h1" variant="h5" align="center" gutterBottom>
            Admin Login
            </Typography>

            <Box component="form" onSubmit={(e) => { e.preventDefault(); handleLogin(e); }} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email?.[0]}
                disabled={isLoading}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password?.[0]}
                disabled={isLoading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={isLoading}
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </Button>
              
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
    </div>
  );
};

export default Login;